export function isActionProject(user, project = null) {
    const admins = ["amitnyc007@gmail.com", "support@redirectmapper.com"];
    return (user && admins.includes(user.user_id)) || 
        (user && user.user_id && user.org && user.user_id === user.org.main_user) || 
        (user && (user?.role === "team" || user?.role === "owner"));
}

export function isAdminUser(user) {
    return user && user?.org && user?.org?.main_user === user?.user_id;
}